import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class TabsList extends UcoastEl {
    static htmlSelector = 'tabs-list'

    buttons: NodeListOf<HTMLButtonElement>
    panels: NodeListOf<HTMLElement>
    wrapper: HTMLElement

    constructor() {
        super()
        this.buttons = q.rl('.tabs__link', this)
        this.wrapper = q.rc(this, '.tabs')
        this.panels = q.rl('.tab-panel-item', this.wrapper)

        this.buttons.forEach(button => {
            button.addEventListener('click', this.onClickButton.bind(this))
        })
    }

    onClickButton(e: Event) {
        const target = e.currentTarget as HTMLButtonElement
        if(!target) return
        const tab = target.dataset.tab
        this.buttons.forEach(button => {
            button.classList.toggle('active', tab == button.dataset.tab)
        })

        this.panels.forEach(panel => {
            panel.classList.toggle('hidden', tab != panel.dataset.tab)
        })
    }
}
